import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppConfig } from '../../AppConfig';
import { AppTheme, AppStyles } from '../../styles/AppTheme';
import { CommonStyles } from '../../styles/Styles';
import TextField from '@material-ui/core/TextField';
import { MuiPickersUtilsProvider, TimePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import momentTz from 'moment-timezone';
import moment from 'moment';
import { ImageComponent } from '../../components/quizzing/ImageComponent';

export class TimeComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  onTimeChange = (e, key) => {
    this.setState({ [key]: moment(e).valueOf() });
    this.props.handleState(key, moment(e).valueOf())
  }

  render() {
    return (
      <div className={css(CommonStyles.outerContainer)}>
        <div>
          {this.props.mainTitle &&
            <div className={css(CommonStyles.questionMainTitleContainer)}>
              <p className={css(CommonStyles.questionMainTitle)}>{this.props.mainTitle}</p>
              {this.props.showInformationPopup &&
                <div className={css(CommonStyles.questionDetailContainer)} onClick={() => this.props.showInformationPopup(this.props.data)}>
                  <p className={css(CommonStyles.questionDetailContent)}>i</p>
                </div>
              }
            </div>
          }
          {this.props.data.subTitle &&
            <p className={css(CommonStyles.questionSubTitle)}>{this.props.data.subTitle}</p>
          }
        </div>
        {this.props.data.image &&
          <div className={css(CommonStyles.outerImageContainer)}>
            <ImageComponent data={this.props.data} />
          </div>
        }
        <div className={css(this.props.survey ? Styles.innerContainer : CommonStyles.innerContainer)}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <TimePicker
              name={this.props.data.id}
              className={this.props.disabled ? css(CommonStyles.textFieldDisabled) : css(CommonStyles.textField)}
              value={this.state[this.props.data.id] ? momentTz(this.state[this.props.data.id]) : null}
              onChange={e => this.onTimeChange(e, this.props.data.id)}
              placeholder='Time'
              InputProps={{
                disableUnderline: true,
                classes: {
                  root: this.props.disabled ? css(CommonStyles.textFieldContentInputDisabled) : css(CommonStyles.textFieldContentInput)
                }
              }}
            />
          </MuiPickersUtilsProvider>
        </div>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  innerContainer: {
    marginTop: 10,
    marginLeft: 20,
    width: '35%',
    '@media (max-width: 767px)': {
      marginLeft: 10,
      width: '96%'
    }
  }
})


// WEBPACK FOOTER //
// ./src/components/quizzing/TimeComponent.js